import React, { useState } from 'react';
import api from '../services/api';
import Footer from '../components/Footer';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');
  const [trimis, setTrimis] = useState(false);
  const [seTrimite, setSeTrimite] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (seTrimite) return; // previne dublu-click / trimitere dubla
    setSeTrimite(true);
    setError('');
    try {
      const res = await api.post('/api/auth/forgot-password', { email });
      setMsg(res.data?.mesaj || 'Dacă adresa de email există în sistem, veți primi un mesaj cu o parolă nouă.');
      setTrimis(true);
    } catch (err) {
      setError(err.response?.data?.error || 'Eroare la trimiterea cererii');
      setSeTrimite(false);
    }
  };

  return (
    <div className="page-with-footer">
      <div className="page-body">
        <div className="login-page">
          <div className="login-box">
            <div className="login-logo">
              <h2>🔑 Am uitat parola</h2>
            </div>
            {error && <div className="login-error">{error}</div>}
            {msg && <div style={{background:'#e8f8ee',color:'#1a7a3a',padding:'8px 10px',borderRadius:4,fontSize:12,marginBottom:12,textAlign:'center'}}>{msg}</div>}

            {!trimis && (
              <form onSubmit={handleSubmit}>
                <p style={{fontSize:13,color:'#555',marginBottom:14}}>
                  Introduceți adresa de email cu care vă conectați. Dacă există în sistem,
                  veți primi o parolă nouă pe această adresă.
                </p>
                <div className="form-group"><label>Email</label>
                  <input type="email" value={email} onChange={e => setEmail(e.target.value)} required /></div>
                <button className="login-submit" type="submit" disabled={seTrimite}>
                  {seTrimite ? 'Se trimite...' : 'Trimite parola nouă'}
                </button>
              </form>
            )}

            <div style={{textAlign:'center',marginTop:14}}>
              <a href="/login" style={{fontSize:12,color:'#2d6ca2'}}>← Înapoi la login</a>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}
